import { cva } from 'class-variance-authority';

export const customHeaderClass = cva(['flex', 'items-center', 'justify-between', 'px-[10px]']);

export const datePickerMonthClass = cva(['text-button-bold text-black w-full']);